import { recipientMiscDocConstants } from '../constants';
import { saveParams, deleteParams, createParams } from './base.reducers';

const name = 'recipientMiscDocs';

const initialState = {
	saveLoading: 0,
	saveSuccess: false,
	deleteLoading: 0,
	allLoading: 0,

	recipientMiscDocs: [],
	recipientMiscDocsById: {}
};

export default (state = initialState, payload) => {
	const { type, data } = payload;
	switch (type) {
		// Save and edit misc docs
		case recipientMiscDocConstants.SAVING_RECIPIENT_MISC_DOC_REQUEST:
			return {
				...state,
				saveSuccess: false,
				saveLoading: state.saveLoading + 1,
			};
		case recipientMiscDocConstants.SAVING_RECIPIENT_MISC_DOC_SUCCESS:
			const { form } = data;
			return {
				...saveParams({ name, state, form }),
				saveLoading: state.saveLoading - 1,
				saveSuccess: true
			};
		case recipientMiscDocConstants.SAVING_RECIPIENT_MISC_DOC_FAILURE:
			return {
				...state,
				saveLoading: state.saveLoading - 1,
			};
		// Delete misc doc
		case recipientMiscDocConstants.DELETE_RECIPIENT_MISC_DOC_REQUEST:
			return {
				...state,
				deleteLoading: state.deleteLoading + 1,
			};
		case recipientMiscDocConstants.DELETE_RECIPIENT_MISC_DOC_SUCCESS:
			const id = data;
			return {
				...deleteParams({ name, state, id }),
				deleteLoading: state.deleteLoading - 1
			};
		case recipientMiscDocConstants.DELETE_RECIPIENT_MISC_DOC_FAILURE:
			return {
				...state,
				deleteLoading: state.deleteLoading + 1,
			};
		// Load misc docs
		case recipientMiscDocConstants.LOAD_RECIPIENT_MISC_DOCS_REQUEST:
			return {
				...state,
				allLoading: state.allLoading + 1,
			};
		case recipientMiscDocConstants.LOAD_RECIPIENT_MISC_DOCS_SUCCESS:
			return {
				...createParams({ name, state, data: data.data }),
				allLoading: state.allLoading - 1
			};
		case recipientMiscDocConstants.LOAD_RECIPIENT_MISC_DOCS_FAILURE:
			return {
				...state,
				allLoading: state.allLoading - 1,
			};
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/redux/reducers/recipientMiscDoc.reducers.js